module.exports = __webpack_public_path__ + "img/afl.baaeb770.png";